'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeMatterIcon = ({ sx }) => {
  const color1 = sx?.color1 || '#d8dce5'
  const color2 = sx?.color2 || '#3D517B'

  return (
    <SvgIcon sx={sx} data-testid="LargeMatterIcon">
      <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1107_29)">
          <path
            d="M17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0Z"
            fill={color1}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.3884 21.3795L18.585 18.1829C19.0731 17.6947 19.0731 16.9033 18.585 16.4151C18.0968 15.927 17.3054 15.927 16.8172 16.4151L13.6207 19.6117L8.71377 17.1582C7.72912 16.6659 7.81564 15.2333 8.85237 14.863L23.9211 9.48133C24.9144 9.12658 25.8735 10.0857 25.5188 11.0789L20.137 26.1478C19.7668 27.1845 18.3341 27.271 17.8418 26.2862L15.3884 21.3795Z"
            fill={color2}
          />
          <path
            d="M17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0Z"
            fill={color1}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2097 7.7097C14.6641 7.25529 15.2804 7 15.9231 7H20.0769C20.7196 7 21.3359 7.25529 21.7903 7.7097C22.2447 8.16412 22.5 8.78044 22.5 9.42308V11.1538C22.5 11.7274 22.0351 12.1923 21.4615 12.1923C20.888 12.1923 20.4231 11.7274 20.4231 11.1538V9.42308C20.4231 9.33128 20.3866 9.24323 20.3217 9.1783C20.2568 9.11339 20.1687 9.07692 20.0769 9.07692H15.9231C15.8313 9.07692 15.7432 9.11339 15.6783 9.1783C15.6134 9.24323 15.5769 9.33128 15.5769 9.42308V11.1538C15.5769 11.7274 15.112 12.1923 14.5385 12.1923C13.9649 12.1923 13.5 11.7274 13.5 11.1538V9.42308C13.5 8.78044 13.7553 8.16412 14.2097 7.7097Z"
            fill={color2}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0769 10.4615C9.92987 10.4615 9 11.3914 9 12.5385V22.9231C9 24.0701 9.92987 25 11.0769 25H24.9231C26.0701 25 27 24.0701 27 22.9231V12.5385C27 11.3914 26.0701 10.4615 24.9231 10.4615H11.0769Z"
            fill={color2}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4038 15.3077C15.4038 14.8298 15.0164 14.4423 14.5384 14.4423C14.0605 14.4423 13.673 14.8298 13.673 15.3077V20.8462C13.673 21.3241 14.0605 21.7115 14.5384 21.7115C15.0164 21.7115 15.4038 21.3241 15.4038 20.8462V15.3077ZM22.3269 15.3077C22.3269 14.8298 21.9394 14.4423 21.4615 14.4423C20.9836 14.4423 20.5961 14.8298 20.5961 15.3077V20.8462C20.5961 21.3241 20.9836 21.7115 21.4615 21.7115C21.9394 21.7115 22.3269 21.3241 22.3269 20.8462V15.3077Z"
            fill={color1}
          />
        </g>
        <defs>
          <clipPath id="clip0_1107_29">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LargeMatterIcon.propTypes = {
  sx: PropTypes.object
}
